import {objectFromEntries} from '@benchling/js-utils';

import {getFeatureLayersForRegionModels, LayersDict} from 'molbio/maps/linear/LayeringHelpers';
import {TranscriptionMetadata} from 'molbio/TranscriptionsUtil';

import {LayersData} from '../MapsUtil';

export function transcriptionId(transcription: TranscriptionMetadata): string {
  return `${transcription.rnaSequence.id}-${transcription.start}-${transcription.end}-${transcription.isReverseComplement}`;
}

export function getTranscriptionLayers(
  transcriptions: Array<TranscriptionMetadata>,
  sequenceLength: number
): LayersData<TranscriptionMetadata & {cid: string}> {
  return getFeatureLayersForRegionModels(
    transcriptions,
    sequenceLength,
    (transcription) => transcriptionId(transcription),
    false
  );
}

export function getTranscriptionAnnotationsLayersDict(
  sliceModels: Array<TranscriptionMetadata>,
  sequenceLength: number
): LayersDict {
  const {layers} = getTranscriptionLayers(sliceModels, sequenceLength);
  const dedupedLayerIndices = new Set(layers.map(({layer}) => layer));
  const orderedDedupedLayerIndices = [...dedupedLayerIndices].sort((i, j) => i - j);
  return objectFromEntries(orderedDedupedLayerIndices.map((layerIndex, i) => [layerIndex, i]));
}
